import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import style from "./style.css";
import throttle from "/app/src/lib/throttle";
import ConversationModel from "/app/src/model/Conversation/model";
import UserModel from "/app/src/model/User/model";
import * as QuickResponseSelectors from "/app/src/model/QuickResponse/selector";
import MessagesList from "/app/src/component/Conversation/MessagesList";
import ConversationSelector from "/app/src/model/Conversation/selector";
import UserSelector from "/app/src/model/User/selector";
import { SystemSelector } from "/app/src/model/System";
import QuickResponseModal from "./QuickResponseModal";
import { Spinner, Flex, SVGButton, MarkdownEditor } from "/app/src/component";
import FileInput from "./FileInput";
import Modal from "react-responsive-modal";
import { history } from "/app/src/store";
import { EditorState } from "draft-js";
import {
  textToEditorState,
  editorStateToJson,
} from "/app/src/component/Markdown";

import { getDefaultKeyBinding } from "draft-js";

class Conversation extends React.Component {
  constructor(props) {
    super(props);
    //Oddly, file bubble text both reflects the texts and if there is a file ready to be sent.
    this.state = {
      messageBoxValue: "",
      toogle: "",
      fileBubbleText: "",
      isUploadingFile: false,
      conversationType: props.conversationType,
    };

    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this._renderMessageBox = this._renderMessageBox.bind(this);
    this._throttleTyping = this._throttleTyping.bind(this);
    this._handleToogle = this._handleToogle.bind(this);
    this._handleSendMessage = this._handleSendMessage.bind(this);
    this._renderQuickResponseModal = this._renderQuickResponseModal.bind(this);
    this._onQuickModalItemSelected = this._onQuickModalItemSelected.bind(this);
    this.setFileBubbleText = this.setFileBubbleText.bind(this);
    this.fileUploadFinish = this.fileUploadFinish.bind(this);
    this.messageBoxRef = React.createRef();
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    this.kickoutUnauthorized();
    if (this.props.room !== prevProps.room) {
      if (this.textarea) {
        //this.textarea.focus();
      }
    }
  }

  componentDidMount() {
    this.kickoutUnauthorized();
  }

  kickoutUnauthorized() {
    if (this.props.conversationType === "ticket_assigned_taken") {
      const participants = this.props.conversationMembers.map(
        (member) => member.id
      );
      if (!participants.has(this.props.userId)) history.push({ pathname: "/" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.conversationType !== this.props.conversationType) {
      this.setState({ conversationType: nextProps.conversationType });
    }
  }

  _handleToogle(toogle) {
    if (toogle === this.state.toogle) {
      this.setState({ toogle: "" });
    } else {
      this.setState({ toogle: toogle });
    }
  }

  closeModal() {
    this.setState({ toogle: "" });
  }

  _handleSendMessage() {
    // this only send file if there is one
    if (this.state.fileBubbleText) {
      this.uploadButtonRef.uploadFile(this.fileUploadFinish);
      this.setState({ isUploadingFile: true });
    }

    let value = editorStateToJson(this.state.editorState);
    let entryBody = value.trim();

    //Dont dispatch message if its empty
    if (entryBody !== "") {
      this.props.dispatch(
        ConversationModel.addUnconfirmedEntry(this.props.room, entryBody)
      );
    }
    this.setState({
      editorState: EditorState.moveFocusToEnd(EditorState.createEmpty()),
    });
  }

  onEditorStateChange(value) {
    this.setState({ editorState: value });
    this._throttleTyping();
  }

  _throttleTyping() {
    throttle(
      this.props.dispatch(
        ConversationModel.emitUserWritingClient(this.props.route[1]),
        2000
      )
    );
  }

  _renderMessageBox(room) {
    let sendImg = "/images/Chat_Send_2X.svg";
    let sendActive = false;

    if (this.state.rawContent || this.state.fileBubbleText !== "") {
      sendImg = "/images/Chat_Send_Hover_2X.svg";
      sendActive = true;
    }

    const FileInputButton = (
      <FileInput
        setFileBubbleText={this.setFileBubbleText}
        room={room}
        ref={(btn) => {
          this.uploadButtonRef = btn ? btn.getWrappedInstance() : null;
        }}
      />
    );
    const QuickResponseButton = (
      <SVGButton
        size="small"
        src="/images/ChatQuickResponse.svg"
        color="black"
        hover="darkblue"
        active={this.state.toogle === "quickResponse"}
        onClick={() => this._handleToogle("quickResponse")}
      />
    );
    const messageKeyBindingFn = (e) => {
      if (e.keyCode === 13) {
        this._handleSendMessage();
        return "message-send";
      }
      return getDefaultKeyBinding(e);
    };
    const SendButton = (
      <SVGButton
        marginLeft="auto"
        color="black"
        hover="darkblue"
        src={sendImg}
        active={sendActive}
        onClick={() => this._handleSendMessage()}
      />
    );

    return (
      <MarkdownEditor
        editorState={this.state.editorState}
        onEditorStateChange={this.onEditorStateChange}
        customButtons={[FileInputButton, QuickResponseButton, SendButton]}
        keyBindingFn={messageKeyBindingFn}
        newText={this.state.newText}
        placeholder="Skriv ditt meddelande..."
      />
    );
  }
  _onQuickModalItemSelected(text) {
    this.setState({
      toogle: "",
      editorState: EditorState.moveFocusToEnd(textToEditorState(text)),
    });
  }
  _renderQuickResponseModal() {
    return (
      <Modal
        styles={{
          modal: { padding: "0px", background: "none", boxShadow: "none" },
        }}
        showCloseIcon={true}
        open={this.state.toogle === "quickResponse"}
        onClose={this.closeModal}
        center
      >
        <QuickResponseModal
          onSelected={this._onQuickModalItemSelected}
          quickResponses={this.props.quickResponses}
          responseModalRef={this.responseModalRef}
          focusTextArea={this.focusTextArea}
        />
      </Modal>
    );
  }

  focusTextArea() {
    //this.textarea.focus()
  }

  fileUploadFinish() {
    //Invoked as a callback at the end of file upload in model
    this.setState({ isUploadingFile: false, fileBubbleText: "" });
  }

  setFileBubbleText(name) {
    this.setState({ fileBubbleText: name });
  }

  _renderFile() {
    const bubbleText = this.state.fileBubbleText;
    if (this.state.fileBubbleText)
      return (
        <Flex hAlignContent="left" vAlignContent="center">
          <Flex
            className={
              this.state.isUploadingFile
                ? style.FileBubble
                : style.FileBubble + " " + style.FileBubbleSending
            }
          >
            <div
              className={
                this.state.isUploadingFile
                  ? style.FileBubbleText + " " + style.FileBubbleTextSending
                  : style.FileBubbleText
              }
            >
              {bubbleText}
            </div>
            {!this.state.isUploadingFile && (
              <SVGButton
                className={style.FileCancelButton}
                onClick={this.uploadButtonRef.unloadFile}
                src="/images/Close_M.svg"
                color="black"
                size="20px"
                hover="black"
              />
            )}
          </Flex>
          <Flex
            className={style.LoadingFile}
            height="100%"
            hAlignContent="center"
          >
            {this.state.isUploadingFile ? (
              <Spinner type={"fountaindrops"} />
            ) : (
              ""
            )}
          </Flex>
        </Flex>
      );
    return null;
  }

  __claimButtonClick(room) {
    return () => {
      this.props.dispatch(UserModel.claimingTicket(room));
    };
  }

  render() {
    const room = this.props.route[1];

    if (!this.props.conversationType) {
      return (
        <Flex center grow fontSize="22px">
          Inga pågående konversationer
        </Flex>
      );
    }
    return (
      <Flex grow h="100%" overflow="hidden">
        <Flex
          className={style.center}
          column
          grow
          position="relative"
          overflow="hidden"
        >
          <Flex hAlignContent="center" grow column overflow="hidden">
            <MessagesList room={room} isTyping={this.props.isTyping} />

            {this._renderQuickResponseModal()}
          </Flex>

          {this.props.conversationType === "unassigned" ? (
            <Flex
              width="100%"
              center
              height="140px"
              shrink={0}
              background="darkwhite"
              z={1}
            >
              <SVGButton
                text="Svara"
                fontSize="45px"
                color="black"
                border
                src="/images/ErrandTransfer_M.svg"
                hover="blue"
                onClick={this.__claimButtonClick(room)}
                width="240px"
                height="85px"
              />
            </Flex>
          ) : (
            <Flex shrink={0} padding="0px 5px 10px 5px">
              <Flex column width="100%">
                {this._renderFile()}
                {this._renderMessageBox(room)}
              </Flex>
            </Flex>
          )}
        </Flex>
      </Flex>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let route = SystemSelector.getParams(state);
  const quickResponses = QuickResponseSelectors.getQuickResponses(state);
  const isTyping = ConversationSelector.getIsTyping(state, route[1]);
  const conversation = ConversationSelector.getByRoom(state, route[1]);

  let conversationType = ConversationSelector.typeOf(conversation);
  const conversationMembers = ConversationSelector.getParticipantsId(
    conversation
  );
  const userId = UserSelector.getId(state);
  return {
    quickResponses: quickResponses,
    route: route,
    room: route[1],
    isTyping: isTyping,
    conversationType: conversationType,
    conversationMembers: conversationMembers,
    userId: userId,
  };
}

export default withRouter(connect(mapStateToProps)(Conversation));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Conversation/index.js